module.exports = __webpack_public_path__ + "img/open_order.212d6fb5.png";